// Contexto de la cadena en el topbar de Inventario; el periodo vive en la banda de la pantalla.
import { Info } from 'lucide-react';

const TOPBAR_LABEL = 'text-[10px] font-bold uppercase tracking-[0.04em] text-muted-foreground';

/** Contexto del topbar. El tenant sale del scope RBAC: no hay selector. */
export function InventoryContextControls({
    tenantName,
    adminName,
}: {
    tenantName: string;
    adminName: string;
}) {
    return (
        <div className="flex flex-col items-end gap-0.5">
            <div className="flex items-center gap-2">
                <span className={TOPBAR_LABEL}>Contexto:</span>
                <span className="text-[11.5px] font-semibold text-foreground">{tenantName}</span>
                <span
                    title="Solo ves y mueves inventario de tus tiendas."
                    className="inline-flex cursor-help items-center gap-1 rounded-full border border-info-soft-border bg-info-soft px-[7px] py-0.5 text-[9.5px] font-semibold text-info"
                >
                    <Info className="size-2.5" aria-hidden />
                    aislado
                </span>
            </div>
            <div className="text-[10px] text-muted-foreground">{`Admin: ${adminName}`}</div>
        </div>
    );
}
